import "./footer.css";

function Footer() {
  return (
    <div className="footer-top">
      <div>
        {" "}
        <p>
          © {new Date().getFullYear()} Developed by Mudith Perera | All rights
          reserved.
        </p>
      </div>
    </div>
  );
}
export default Footer;
